import { FC } from 'react';
import { chakra, Icon } from '@chakra-ui/react';
import ReactPagination, { PaginationProps } from 'rc-pagination';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { paginationStyles } from './pagination-styles';

const ChakraPagination = chakra(ReactPagination);

export const Pagination: FC<PaginationProps> = ({ locale, ...props }) => {
  return (
    <ChakraPagination
      locale={locale}
      prevIcon={<Icon as={BiChevronLeft} data-testid="prev-page" />}
      nextIcon={<Icon as={BiChevronRight} data-testid="next-page" />}
      sx={paginationStyles}
      {...props}
    />
  );
};
